// client/src/services/PaymentService.js
import axios from 'axios';
import { BACKEND_URL } from "../utils/serverData";

export const initiateKlarnaPayment = async (paymentData) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/payments/klarna/create`, paymentData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPaymentStatus = async (orderId) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/payments/klarna/status/${orderId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};